import { useEffect, useState } from "react";

import {
  AddPendingChecklist,
  SortableList
} from "modules/AppointmentDetails/components/Interventions/components/InterventionChecklists/components/PendingChecklists/components";
import "modules/AppointmentDetails/components/Interventions/components/InterventionChecklists/components/PendingChecklists/PendingChecklists.scss";

import type { UniqueIdentifier } from "@dnd-kit/core";
import type { Appointment, Checklist, Intervention, InterventionPendingChecklist } from "models";

export type SortablePendingChecklists = { id: UniqueIdentifier } & InterventionPendingChecklist;

type PendingChecklistsProps = {
  intervention: Intervention;
  offset: number;
  checklists?: Checklist[];
  appointment?: Appointment;
};

export type InterventionPendingChecklistItems = InterventionPendingChecklist & { id: UniqueIdentifier };

export const PendingChecklists = ({ intervention, offset, checklists, appointment }: PendingChecklistsProps) => {
  const sortablePendingChecklists = intervention.pending_checklists?.map(pc => ({ ...pc, id: offset + pc.ordering })) || [];
  const [items, setItems] = useState<SortablePendingChecklists[]>(sortablePendingChecklists);

  useEffect(() => {
    if (intervention.pending_checklists) setItems(sortablePendingChecklists);
  }, [intervention.pending_checklists]);

  return (
    <div className="PendingChecklists">
      <div className="sortable-list-container">
        <SortableList items={items} setItems={setItems} checklists={checklists} />
      </div>

      <AddPendingChecklist intervention={intervention} nextOrdering={sortablePendingChecklists.length + 1} checklists={checklists} appointment={appointment} />
    </div>
  );
};
